// voiceConfig.js
// 🎙️ Unified Browser-Specific Female Voice Mapping (no frontend detection)

// --- Microsoft Edge Voice Map ---
const edgeVoiceMap = {
  "hi-IN": /microsoft swara online.*natural/i,
  "en-US": /microsoft aria online.*natural/i,
  "es-ES": /microsoft elvira online.*natural/i,
  "fr-FR": /microsoft denise online.*natural/i,
};

// --- Google Chrome Voice Map ---
const chromeVoiceMap = {
  "hi-IN": /google.*hindi/i,
  "en-US": /google us english female|google uk english female/i,
  "es-ES": /google español/i,
  "fr-FR": /google français/i,
};

// --- Safari (macOS / iOS) Voice Map ---
const safariVoiceMap = {
  "hi-IN": /lekha/i,
  "en-US": /samantha/i,
  "es-ES": /monica|paulina/i,
  "fr-FR": /amelie|thomas/i,
};

// --- Export all voice maps for frontend use ---
export { edgeVoiceMap, chromeVoiceMap, safariVoiceMap };
